import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
//Componentes
import CajaCrear from "../globales/cajasCrear/CajaCrear";
import CursoCreado from "./CursoCreado";
import SelectorDeBusqueda from "../globales/elementosFormularios/SelectorDeBusqueda";
import NoHayResultados from "../globales/NoHayResultados";
import VentanaAlerta from "../globales/VentanaAlerta";
import { useTrackedState } from "../../store";

const CursosComponent = (props) => {
  const state = useTrackedState();
  const rolUsuario = state?.planActivo?.tipoUsuario || 'null';
  // const rolUsuario = 'rector';
  const { borrarFiltros, buscarCursos, cambiarSede, isErrorSede, resultadosBusqueda, sedes, textosInterfaz, filtros } = props;
  const { miga_de_pan, vista_general, nuevo, info_curso, botones, no_existe_sede } = textosInterfaz;
  const { busqueda, rector,profesor,header, select, tool_tips } = vista_general;

  //Estados del componente
  const [texto, setTexto] = useState(null);
  const [alturaCursoCreado, setAlturaCursoCreado] = useState();
  //Referencias
  const inputBuscador = useRef(null)
  /*datos de prueba */
  const estaBuscandoCurso = false;

  const actualizarAlturaCursoCreado = (altura) => {
    setAlturaCursoCreado(altura);
  }

  const cambiarOpcion = ({ opcion }) => {
    setTexto(opcion.nombre)
    cambiarSede({ idSede: opcion.id, value: inputBuscador.current.value });
  };

  useEffect(() => {
    if (filtros.sede === null) setTexto(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros])

  const vertodasLasSedes = () => cambiarSede({ idSede: null, value: inputBuscador.current.value })
  return (
    <>
      <div className="ruta">
        <p>{miga_de_pan.principal}</p>
      </div>
      <div className="contenido">
        <h1 className="titulos-principales">{header.titulo}</h1>

        <div className="md:flex justify-between  flex-wrap items-center  py-3">

          <div className={`${rolUsuario==='profesor'?'w-full ':'md:w-7/12 md:order-1'}`}>
            <p className="informacion-principal">{
              `${
                rolUsuario === 'rector'?`${rector?.header?.descripcion 
                  || 'Filtra por colegio (sede) para ver los cursos asociados'}`
                :`${profesor?.header?.descripcion 
                  || 'Aquí encontraras todos los cursos que tienes asignados.'}`
              }`
            }</p>
          </div>

          <div className="w-full md:flex justify-between flex-wrap mt-3 gap-4 md:order-3">
            {
              rolUsuario === 'rector' &&
              <div className="md:w-5/12 xl:w-3/12">
                <SelectorDeBusqueda
                  cambiarElegido={cambiarOpcion}
                  filtro={filtros.sede}
                  filtroMensajeNoexite={select.no_existe}
                  opciones={sedes}
                  textoDefault={select.placeholder}
                  textoElegido={texto}
                  superposicion={true}
                  verTodasLasOpciones={{
                    textos: select.ver_todo,
                    alVertodasLasOpciones: vertodasLasSedes,
                  }}
                />

              </div>
            }

            <div className={`${rolUsuario === 'profesor' ? 'w-full' : 'md:w-6/12 xl:w-451p mt-6 md:mt-0 mb-6'}`}>
              <div className="relative w-full h-full">
                <input
                  className="w-full"
                  onChange={() => { buscarCursos({ value: !!inputBuscador.current ? inputBuscador.current.value : '' }) }}
                  placeholder={busqueda.placeholder}
                  ref={inputBuscador}
                  type="text"
                />

                <button className="focusable-secondary absolute right-0 top-0 w-10 h-full">
                  <span className="icon-lupa onsurface-var1--color hover:text-morado"></span>
                </button>
              </div>
            </div>

            {/* <div className="w-full alineado-izquierda my-6 md:mt-0">
              <button
                className="boton-pequenio boton-rojo boton_hover_morado"
                onClick={() => borrarFiltros({ refInput: inputBuscador.current })}
              >
                {botones.filtros.borrar}
              </button>
            </div> */}
          </div>
          {
            rolUsuario === 'rector' &&
            <div className="md:flex justify-end items-center md:w-5/12 my-6 lg:my-0 md:order-2">
              <Link
                className="focusable-primary w-full lg:w-auto boton-justo boton-amarillo boton_hover_naranja center px-10"
                to="/cursos/crear-curso">
                {nuevo.titulo}
                <span className="icon-mas ml-3"></span>
              </Link>
            </div>
          }

        </div>




        {(() => {
          if (!isErrorSede) {
            if (resultadosBusqueda.hayResultados) {
              return (
                <div className="grid md:grid-cols-2">
                  <CursoCreado
                    cambiarAlturaCursoCreado={actualizarAlturaCursoCreado}
                    estadoAlturaCurso={alturaCursoCreado}
                    resultados={resultadosBusqueda.resultados}
                    textos={info_curso}
                    textoBotonEditar={botones.editar}
                    tooltips={tool_tips}
                  />
                  {(!estaBuscandoCurso && rolUsuario ==='rector' )&&
                    <CajaCrear
                      altura={alturaCursoCreado}
                      textoCaja={nuevo.titulo} link='/cursos/crear-curso'
                    />
                  }
                </div>
              )
            } else {
              return <NoHayResultados descripcion={busqueda.descripcion} titulo={busqueda.titulo} />
            }
          } else {
            return (
              <VentanaAlerta
                textosInterfaz={{
                  titulo: no_existe_sede.titulo,
                  descripcion: no_existe_sede.descripcion,
                }}
                imagen={{
                  alt: 'blop con un icono de alerta',
                  img: 'alertas/blop-alerta.png',
                }}
              >
                <button
                  className="focusable-secondary boton-pequenio mx-auto py-2  lg:order-3 boton-amarillo boton_hover_morado"
                  onClick={() => borrarFiltros({ refInput: inputBuscador.current })}
                >
                  {botones.filtros.borrar}
                </button>
              </VentanaAlerta>
            )
          }
        })()}
      </div>
    </>
  )
}

export default CursosComponent;
